import React from 'react';
import { Spinner } from "react-bootstrap";
import './LoadingComponent.scss';

class LoadingComponent extends React.Component {
    render() {
        return (
          <div className="loading-component">
            <div className="loading-component__content">
              <Spinner 
                    animation="border" 
                    role="status"
                    variant="light"
                >
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
          </div>
        );
    }
}

export default LoadingComponent;